// tslint:disable:max-line-length

import React from 'react';

export const StatusInfo = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M13.63.5H2.37A1.87,1.87,0,0,0,.5,2.37V13.63A1.87,1.87,0,0,0,2.37,15.5H13.63a1.87,1.87,0,0,0,1.87-1.87V2.37A1.87,1.87,0,0,0,13.63.5ZM8,3A1.25,1.25,0,1,1,6.75,4.25,1.25,1.25,0,0,1,8,3Zm2,10H6V11.5H7V8H6V6.5H9v5h1Z" />
    </svg>
  );
};
